import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppConfigService } from './app-config.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  constructor(private appConfig: AppConfigService, private dialog: MatDialog) {

  }

  private decodeToken(token: string) {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  }

  private hasExpired(token: string) {
    const result = this.decodeToken(token);

    return result.exp * 1000 <= Date.now();
  }

  getToken(endpoint: string = null) {
    if (!endpoint) {
      endpoint = 'https://analysis.windows.net/powerbi/api';
    }

    const tokens = JSON.parse(window.localStorage.getItem('__auth_tokens')) || {};
    if (tokens[endpoint]) {
      const token = tokens[endpoint];
      if (!this.hasExpired(token)) {
        return token;
      }
    }

    let request = {
      tenant: this.appConfig.tenant,
      clientId: this.appConfig.clientId,
      returnUrl: window.location.href,
      endpoint: endpoint
    };

    window.localStorage.setItem('__auth_request', JSON.stringify(request));
    window.location.href = '/assets/login.html';
  }
}
